export default __webpack_public_path__ + "static/media/ip-mon.3ce63ae3.svg";